/**
 * Adds multidimensional group-by support to DX reports. In other words, turns
 * the group by configuration into an array.
 *
 * Source version: 1
 * Destination version: 2
 */
export default (report) => {
    const { definition } = report;

    if (definition.version !== 1) {
        return report;
    }

    definition.version = 2;

    const { globals } = definition;
    globals.groupings = [];

    if (globals.groupByMetadata && globals.groupByMetadataType) {
        const configuration = globals.groupByMetadata.value;
        const type = globals.groupByMetadataType.value?.id;
        const valid = !!(configuration && type);

        globals.groupings.push({
            configuration,
            type,
            valid,
        });
    }

    delete globals.groupByMetadata;
    delete globals.groupByMetadataType;

    return report;
};
